export const calculateTotal = (num1, num2) => {
  const number1 = !isNaN(num1) ? num1:  0;
  const number2 = !isNaN(num2) ? num2:  0;
  const sumAmount = (parseFloat(number1) + parseFloat(number2));
  return sumAmount.toFixed(2)
};